import { Directive, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LazyLoadComponentDef, LazyLoadComponentService } from '@y42/core/lazy-load-component';
import { Asset } from '../../models';
import { AssetSidebarTab, AssetSidebarTabComponent, FeatureAssetSidebarComponentDef } from './asset-sidebar-tab.model';

@Directive({
  selector: '[y42AssetSidebarTab]',
  providers: [LazyLoadComponentService],
})
export class AssetSidebarTabDirective implements AssetSidebarTabComponent<Asset>, OnInit, OnChanges {
  constructor(private readonly lazyLoadComponentService: LazyLoadComponentService<AssetSidebarTabComponent<Asset>>) {}

  @Input() activeTab?: AssetSidebarTab | FeatureAssetSidebarComponentDef;

  ngOnInit(): void {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const previousTab = changes.activeTab?.previousValue as AssetSidebarTab | null;
    const currentTab = changes.activeTab?.currentValue as AssetSidebarTab | null;
    const needsRerender = previousTab !== currentTab;

    if (needsRerender) {
      this.render();
      return;
    }

    this.setProperties();
  }

  private render() {
    const componentDef = this.activeTab?.componentDef;
    if (!componentDef) {
      return;
    }

    this.lazyLoadComponentService.render(componentDef as LazyLoadComponentDef<AssetSidebarTabComponent<Asset>>);
  }

  private setProperties() {
    this.lazyLoadComponentService.setProperties({});
  }
}
